import { SvgIcon, SvgIconProps } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

export default function CopyStopsIcon({
  color = RoutalPalette.primary40,
  ...props
}: { color?: string } & Omit<SvgIconProps, `color`>) {
  return (
    <SvgIcon {...props} viewBox="0 0 15 14" style={{ width: `15px`, height: `15px`, ...props.style }}>
      <defs>
        <clipPath id="clip0_461_19472">
          <rect width="14" height="14" fill="white" transform="translate(0.855469)" />
        </clipPath>
      </defs>
      <g clipPath="url(#clip0_461_19472)" fill="none">
        <rect id="Rectangle 766" x="3.83289" y="2.49561" width="10.4861" height="11.0043" rx="1.5" stroke={color} />
        <path
          id="Vector 6"
          d="M10.6714 0.493652H3.30539C2.19957 0.493652 1.30362 1.39104 1.30539 2.49686L1.31829 10.5501"
          stroke={color}
          strokeLinecap="round"
        />
      </g>
    </SvgIcon>
  );
}
